import React from 'react';
import { Box } from "grommet";

const options = ({ option, active }: {option: {value: string, text: string}, active: boolean}) => {
   return <Box pad="small" background={active ? '#2D3D50': undefined}>
        {option.text}
    </Box>
};

export default React.memo(options);